import React, { Component } from 'react';

//componentes
import Nosotros from './nosotros'

class Index extends Component {

    render(){
        return(
            <div>
                <Nosotros />
            </div>
        );
    }

}
export default Index;